import React, { useState } from "react";
import "../../../styles/orderlist.css";
import { motion } from "framer-motion";
import { MdOutlineInfo } from "react-icons/md";
import { getImageUrl } from "utils/helper";
import { TimeUtils } from "utils/time.utils";
import { ORDER } from "utils/constants";
import OrderRateFeedback from "../orderRateFeedback";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const OrderItemSummary = ({ order, onOrderFeedbackSubmitted }) => {
  const [showPriceTooltipId, setShowPriceTooltipId] = useState(null);

  const getStatusColor = (order) => {
    switch (order.status) {
      case ORDER.STATUS.Delivered:
        return "#4CAF50";
      case ORDER.STATUS.Cancelled:
        return "#FF0000";
      case ORDER.STATUS.OutForDelivery:
      case ORDER.STATUS.ReadToPickup:
        return "#FFC107";
      default:
        return order.seenAt ? "#2196F3" : "#9E9E9E";
    }
  };

  const getStatusText = (order) => {
    switch (order.status) {
      case ORDER.STATUS.ReadToPickup:
        return "Ready to pickup";
      case ORDER.STATUS.OutForDelivery:
        return "Out for delivery";
      case ORDER.STATUS.Delivered:
        return "Delivered";
      case ORDER.STATUS.Cancelled:
        return "Cancelled";
      case ORDER.STATUS.CustomerConfirmationPending:
      case ORDER.STATUS.MerchantAcceptancePending:
      case ORDER.STATUS.MerchantPreparing:
        if (!order.seenAt) {
          return "Processing";
        }
        return "Preparing";
      default:
        return "Pending";
    }
  };

  // Check if user has submitted any review/rating for this order

  // Check if review form should be open by default

  return (
    <>
      <motion.div
        key={order.id}
        className="all_order_card"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.3 }}
      >
        <div className="all_order_header">
          <span className="all_order_date">
            <Link to={`/order/${order.id}`}>#{order.orderNumber}</Link> Order:{" "}
            {TimeUtils.formatTime(order.createdAt)}
          </span>

          <span
            className="all_order_status"
            style={{ backgroundColor: getStatusColor(order) }}
          >
            {getStatusText(order)}
          </span>
        </div>
        <div className="all_order_products">
          {order.orderItems?.map((orderItem) => (
            <motion.div
              key={orderItem.id}
              className="all_order_product"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: 0.1 }}
            >
              <motion.img
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.3 }}
                src={getImageUrl(orderItem.product?.imageUrl)}
                alt={orderItem.product?.name}
                className="all_order_product_image"
              />
              <div className="all_order_product_info">
                <span className="all_order_product_name">
                  {orderItem.product?.name} X {orderItem.quantity}
                </span>
                <span className="all_order_product_shop">
                  {orderItem.product?.merchant?.displayName}
                </span>
                <span className="all_order_product_price">
                  ₹{orderItem.sellingPriceTotal}
                </span>
              </div>
            </motion.div>
          ))}
        </div>
        <div className="all_order_footer">
          <span className="all_order_total_label">Total Amount:</span>
          <span className="all_order_total_price">
            ₹{order.totalAmount}
            <span
              className="price-info-icon"
              onMouseEnter={() => setShowPriceTooltipId(order.id)}
              onMouseLeave={() => setShowPriceTooltipId(null)}
            >
              <MdOutlineInfo
                size={10}
                style={{
                  marginLeft: "3px",
                  marginTop: "10px",
                  color: "#e2542c",
                }}
              />
              {showPriceTooltipId === order.id && (
                <motion.div
                  initial={{ opacity: 0, y: 10 }}
                  animate={{ opacity: 1, y: 0 }}
                  className="price-tooltip-orderlist-page"
                >
                  <ul>
                    <li>
                      {" "}
                      Delivery/Service charge applied in the final amount{" "}
                    </li>
                  </ul>
                </motion.div>
              )}
            </span>
          </span>
        </div>

        {order.status === ORDER.STATUS.Delivered && (
          <OrderRateFeedback
            order={order}
            onSubmit={() => {
              onOrderFeedbackSubmitted();
            }}
          />
        )}
      </motion.div>
      <ToastContainer
        id="cart-toast-container"
        style={{ width: "300px" }}
        position="top-center"
        autoClose={3000}
      />
    </>
  );
};

export default OrderItemSummary;
